<div class="row">
    <!-- <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
        <label>Filiale :
            <span class="required_champs">*</span>
        </label>
        <ng-select [(ngModel)]="filiale_id" (change)="load_filiale_data()" [disabled]="true"
            placeholder="Choisissez " name="filiale_id" id="filiale_id" [multiple]="false" [closeOnSelect]="true">
            <ng-option *ngFor="let item of itemsFiliale" [value]="item.id">{{ item?.libelle }}
            </ng-option>
        </ng-select>
    </div> -->
   
    <div class="col-md-2" style="position: relative;">
        <!-- <label>
                    Garant :
                </label> -->
        <label (click)="openModalDetailGarant()" [ngClass]="{'isItemSelected':itemToSearch.garant_id}">Garant :
            <!-- <span class="required_champs">*</span> -->
        </label>
        <ng-select (change)="onChangeGarant();getItems();currentPage=0"  [(ngModel)]="itemToSearch.garant_id" placeholder="Choisissez garant " name="garant_id" id="garant_id"
            [multiple]="false" [closeOnSelect]="true" >
            <ng-option *ngFor="let item of itemsGarant" [value]="item.id">{{
                item?.libelle }}
            </ng-option>
        </ng-select>
        <!-- <button class="btn btn-success btn-add" (click)="openAddGarantModal()"><i class="fa fa-plus"></i></button> -->
    </div>
    <div class="col-md-2" style="position: relative;">
        <label (click)="openModalDetailPolice()" [ngClass]="{'isItemSelected':itemToSearch.police_id}">Police :
        </label>
        <ng-select (change)="onChangePolice();getItems();currentPage=0" [(ngModel)]="itemToSearch.police_id"
            placeholder="Choisissez police " name="police_id" id="police_id" [multiple]="false" [closeOnSelect]="true">
            <ng-option *ngFor="let item of itemsPolice" [value]="item.id">{{
                item?.libelle }}
            </ng-option>
        </ng-select>
        <!-- <button class="btn btn-success btn-add" (click)="openAddPoliceModal()"><i class="fa fa-plus"></i></button> -->
    </div>
    <div class="col-md-2" style="position: relative;">
        <label  [ngClass]="{'isItemSelected':itemToSearch.college_id}">Collège :
        </label>
        <ng-select (change)="getItems();currentPage=0" [(ngModel)]="itemToSearch.college_id"
            placeholder="Choisissez collège " name="college_id" id="college_id" [multiple]="false"
            [closeOnSelect]="true">
            <ng-option *ngFor="let item of itemsCollege" [value]="item.id">{{
                item?.libelle }}
            </ng-option>
        </ng-select>
    </div>
    <!-- <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container" style="position:relative">
        <label>Avenant :
            <span class="required_champs">*</span>
        </label>
        <ng-select [(ngModel)]="itemToSearch.avenant_id"  placeholder="Choisissez " name="avenant_id" id="avenant_id"
            [multiple]="false" [closeOnSelect]="true">
            <ng-option *ngFor="let item of itemsAvenant" [value]="item.id">{{
                item?.libelle }}
            </ng-option>
        </ng-select>
        <button (click)="openAddAvenant()" class="btn btn-success" style="position: absolute;
            right: 0;
            top: 0;
            border-radius: 50px;
        "><i class="fa fa-plus"></i></button>
    </div> -->
    <div class="col-md-2" style="position: relative;">
        <label>
            Matricule assuré:
        </label>

        <input (keyup)="getItems();currentPage=0"  type="text" placeholder="Matricule assuré" autocomplete="off"
            class="form-control" [(ngModel)]="itemToSearch.matricule_assure" name="matricule_assure" />
    </div>
    <div class="col-md-2" style="position: relative;">
        <label>
            Matricule :
        </label>

        <input (keyup)="getItems();currentPage=0"  type="text" placeholder="Matricule" autocomplete="off"
            class="form-control" [(ngModel)]="itemToSearch.matricule" name="matricule" />
    </div>
    <div class="col-md-2" style="position: relative;">
        <br>
        <button type="button" class="btn btn-md custom_btn_primary pull-left"
            (click)="currentPage=0;getItems()">
            <i class="fa fa-search"></i>&nbsp; Recherche
        </button>
    </div>

</div>

<div class="body table-responsive">
    <table class="table table-stripped table-bordered table-hover">
        <thead>

            <!-- <tr class="custom-table-head">
                <th colspan="12" style="text-align: right;">
                    <button class="btn btn-primary">Nouvel avenant</button>
                </th>
            </tr> -->
            <tr class="custom-table-head">
                <th>
                    <a style="cursor: pointer" (click)="currentPage = 0; getItems()" title="Actualiser">
                        <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                </th>
                <th>Nom prenoms</th>
                <th>Matricule</th>
                <th>Assuré</th>
                <th>Statut</th>
                <th>Garant</th>
                <th>Police</th>
                <th>Collège</th>
                <th>Date naissance</th>
                <!-- <th>Email</th> -->
                <!-- <th>Téléphone</th> -->
                <th>Avenant</th>
                <th>Photo</th>
                <!-- <th class="txt-align-center">Actions</th> -->
            </tr>
        </thead>

        <tbody>
            <tr  style="cursor: pointer;" (click)="item.isChecked=!item.isChecked;checkUnchek()" [class.isAssure]="item?.statut_codification =='A'" [class.isSupplementaire]="item?.is_supplementaire"
                *ngFor="let item of items; let indice = index">
                <td class="txt-align-center">
                    <input type="checkbox" [(ngModel)]="item.isChecked" >
                    {{ currentPage>1?(((currentPage - 1) *
                    this.itemsPerPage) + (indice+1)):indice+1 }}
                </td>
                <td>{{ item?.nom }} {{ item?.prenom }}</td>
                <td>{{ item?.matricule }}</td>
                <td>{{ item?.matricule_assure }}</td>
                <td>{{ item?.statut_codification }}</td>
                <td>{{ item?.garant_codification }}</td>
                <td>{{ item?.police_libelle }}</td>
                <td>{{ item?.college_libelle }}</td>
                <td>{{ item?.date_naissance | dateFormat }}</td>
                <!-- <td>{{ item?.email }}</td> -->
                <!-- <td>{{ item?.telephone | mask:'00 00 00 00 00' }}</td> -->
                <td>{{ item?.avenant_libelle }}</td>
                <td>
                    <img [src]="item.image_url | safe" (error)="handleImageError(item)" style="
                  width: 30px;
                  height: 30px;
                  display: block;
                  border-radius: 50px;
                " />
                </td>
                <!-- <td>
                    <div ngbDropdown class="d-inline-block">
                        <button type="button" class="btn btn-custom-action-dropdown" id="action"
                            ngbDropdownToggle>Actions</button>
                        <div ngbDropdownMenu aria-labelledby="action"
                            class="dropdown-validation-plainte">
                            <button ngbDropdownItem (click)="openAddItemModal(item)">
                                &nbsp;
                                Modifier
                            </button>
                            <button ngbDropdownItem (click)="openAddBeneficiaireItemModal(item)">
                                &nbsp;
                                Ajouter bénéficiaire
                            </button>
                            <button ngbDropdownItem (click)="confirmDelete(item)">
                                &nbsp;
                                Supprimer
                            </button>
                        </div>
                    </div>

                </td> -->
            </tr>
        </tbody>

        <tfoot>
            <tr *ngIf="items && items.length > 0">
                <td colspan="12">
                    <div class="row pagination-part">
                        <div class="col-md-9" style="text-align: center">
                            <pagination [maxSize]="5" [boundaryLinks]="true" [itemsPerPage]="itemsPerPage"
                                [totalItems]="totalItems" [(ngModel)]="currentPage" class="pagination-sm"
                                previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
                                (pageChanged)="pageChanged($event)">
                            </pagination>
                        </div>

                        <div class="col-md-3">
                            <div class="paginator-per-page">
                                <app-element-by-page-paginator (paginationChange)="
                        changePaginationSize($event)
                      " [defaultItemPerPage]="itemsPerPage">
                                </app-element-by-page-paginator>

                                <span class="span_total_entree pull-right">Total : {{ totalItems
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>

            <tr *ngIf="!items || items.length == 0">
                <td colspan="12">
                    <div class="col-md-12 txt-align-center">
                        Aucune donnée disponible
                    </div>
                </td>
            </tr>
        </tfoot>
    </table>
</div>